var map = {
	"./1.jpg": "98a8",
	"./2.jpg": "593c",
	"./3.jpg": "6800",
	"./4.jpg": "ffd7",
	"./5-2.jpg": "1f4e",
	"./5-3.jpg": "5681",
	"./5-4.jpg": "85c8",
	"./5.jpg": "546a",
	"./6.jpg": "129c",
	"./bali.jpg": "9512",
	"./before-show.jpg": "4d70",
	"./bg1.png": "72dd",
	"./bg2.png": "89d4",
	"./chiang-mai.jpg": "6880",
	"./cover.jpg": "b2f3",
	"./cover_.jpg": "e581",
	"./destination/chiang-mai.jpg": "aaad",
	"./destination/chiang-mai/cover.jpg": "4ca2",
	"./destination/chiang-mai/thumbnail-cover.jpg": "153d",
	"./destination/koh-samui-resort.jpg": "a669",
	"./destination/koh-samui-resort/cover.jpg": "c700",
	"./destination/koh-samui-resort/thumbnail-cover.jpg": "2309",
	"./destination/legian-bali.jpg": "4d24",
	"./destination/legian-bali/cover.jpg": "9ad5",
	"./destination/legian-bali/thumbnail-cover.jpg": "32af",
	"./destination/phuket.jpg": "fd2e",
	"./destination/phuket/cover.jpg": "648f",
	"./destination/phuket/thumbnail-cover.jpg": "ab5b",
	"./destination/riverside-bangkok.jpg": "1d44",
	"./destination/riverside-bangkok/cover.jpg": "d6e6",
	"./destination/riverside-bangkok/thumbnail-cover.jpg": "9d78",
	"./destination/seminyak-bali.jpg": "88c2",
	"./destination/seminyak-bali/cover.jpg": "9a98",
	"./destination/seminyak-bali/thumbnail-cover.jpg": "001e",
	"./icon-01.png": "fadb",
	"./icon-02.png": "f341",
	"./icon-03.png": "f93c",
	"./intro-1.jpg": "065e",
	"./intro-2.jpg": "da9e",
	"./intro-3.jpg": "515f",
	"./phuket.jpg": "7eeb",
	"./resort/cn/1.jpg": "d503",
	"./resort/cn/2.jpg": "d5f3",
	"./resort/cn/3.jpg": "090d",
	"./resort/cn/4.jpg": "642d",
	"./resort/cn/5.jpg": "bfb1",
	"./resort/cn/6.jpg": "868a",
	"./resort/en/1.jpg": "a59e",
	"./resort/en/2.jpg": "b807",
	"./resort/en/3.jpg": "df04",
	"./resort/en/4.jpg": "5255",
	"./resort/en/5.jpg": "b384",
	"./resort/en/6.jpg": "46c7",
	"./resort/th/1.jpg": "9b3b",
	"./resort/th/2.jpg": "35b1",
	"./resort/th/3.jpg": "92d4",
	"./resort/th/4.jpg": "5d75",
	"./resort/th/5.jpg": "a0b1",
	"./resort/th/6.jpg": "addd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";